import React, { useState } from 'react';
import api from '../services/api';

const Login = ({ onLoginSuccess }) => {
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setErro('');
    try {
      const res = await api.post('/admin/login', { usuario, senha });
      if (res.data.sucesso) {
        localStorage.setItem('mayne_token', res.data.token); // Salva o token
        onLoginSuccess(); // Libera o app
      }
    } catch (err) {
      setErro('Usuário ou senha incorretos.');
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h1 style={styles.title}>Dra. Mayne Porto</h1>
          <p style={styles.subtitle}>Gestão de Consultório</p>
        </div>

        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Usuário</label>
            <input 
              type="text" 
              value={usuario} 
              onChange={(e) => setUsuario(e.target.value)} 
              style={styles.input} 
              required
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Senha</label>
            <input 
              type="password" 
              value={senha} 
              onChange={(e) => setSenha(e.target.value)} 
              style={styles.input} 
              required
            />
          </div>

          {erro && <p style={styles.error}>{erro}</p>}

          <button type="submit" style={styles.button}>Entrar</button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#FAF8F5', height: '100vh', fontFamily: '"Montserrat", sans-serif' },
  card: { backgroundColor: '#FFFFFF', borderRadius: '12px', padding: '50px 40px', width: '100%', maxWidth: '400px', border: '1px solid #EBE6E0', boxShadow: '0 10px 30px rgba(181, 153, 120, 0.1)' },
  header: { textAlign: 'center', marginBottom: '40px' },
  title: { fontSize: '28px', color: '#2C2A29', margin: 0, fontFamily: '"Playfair Display", serif', fontWeight: '500' },
  subtitle: { fontSize: '11px', color: '#B59978', marginTop: '8px', textTransform: 'uppercase', letterSpacing: '2px', fontWeight: '600' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  inputGroup: { display: 'flex', flexDirection: 'column' },
  label: { fontSize: '11px', fontWeight: '600', color: '#7A7571', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' },
  input: { padding: '14px', borderRadius: '8px', border: '1px solid #EBE6E0', backgroundColor: '#FCFBF9', outline: 'none', fontSize: '14px', color: '#2C2A29', transition: 'border-color 0.2s' },
  button: { padding: '16px', backgroundColor: '#B59978', color: '#FFFFFF', border: 'none', borderRadius: '8px', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '1px', cursor: 'pointer', marginTop: '10px', fontWeight: '600' },
  error: { color: '#A67C7C', fontSize: '13px', textAlign: 'center', margin: 0 }
};

export default Login;